module.exports = __webpack_public_path__ + "static/media/tf.c4f2111f.svg";